export const AssignmentVisitState = {
  Planned: 'Planned',
  Complete: 'Complete',
  Ahead: 'Ahead',
  OnTime: 'OnTime',
  Behind: 'Behind',
  StartedLate: 'StartedLate',
};

export const VisitType = {
  OnSite: 0,
  PhoneCall: 1,
};
